/** @format — Expected / overdue awaiting document rows */

import { AlertCircle, ArrowUpRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { formatDateLabel, formatUploadType } from "../utils/documentFormatters";
import type { AwaitingDocumentRow } from "../../shipments/hooks/useShipmentDocuments";
import EscalateBadge from "./EscalateBadge";

function AwaitingUploadIcon() {
  return (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" aria-hidden>
      <path
        d="M6.63787 0.964286C7.5373 0.790224 8.46175 0.790226 9.36118 0.964286C9.6322 1.01674 9.80931 1.27855 9.75701 1.54957C9.70454 1.82068 9.44218 1.99852 9.17107 1.94606C8.39718 1.7963 7.60186 1.79629 6.82797 1.94606C6.55686 1.99852 6.2945 1.82068 6.24204 1.54957C6.18975 1.2786 6.36691 1.01678 6.63787 0.964286Z"
        fill="#737373"
      />
      <path
        d="M9.17107 14.0548C9.44216 14.0023 9.70451 14.1795 9.75701 14.4506C9.80948 14.7217 9.63229 14.9841 9.36118 15.0366C8.46177 15.2106 7.53728 15.2106 6.63787 15.0366C6.36679 14.9841 6.18957 14.7217 6.24204 14.4506C6.29453 14.1795 6.55688 14.0023 6.82797 14.0548C7.60183 14.2045 8.39721 14.2045 9.17107 14.0548Z"
        fill="#737373"
      />
      <path
        d="M11.3254 2.19996C11.4803 1.97138 11.7914 1.91161 12.02 2.0665C12.7807 2.58191 13.4352 3.23884 13.9478 4.00139C14.1018 4.23056 14.0408 4.54134 13.8117 4.69541C13.5825 4.84945 13.2717 4.78852 13.1177 4.55934C12.6766 3.90319 12.1134 3.33811 11.4588 2.89462C11.2302 2.73972 11.1705 2.42856 11.3254 2.19996Z"
        fill="#737373"
      />
      <path
        d="M0.964042 6.63811C1.01654 6.36716 1.27835 6.19 1.54933 6.24228C1.82044 6.29475 1.99828 6.55711 1.94581 6.82822C1.79605 7.60211 1.79606 8.39742 1.94581 9.17132C1.99828 9.44243 1.82044 9.70479 1.54933 9.75725C1.27831 9.80956 1.01649 9.63245 0.964042 9.36142C0.789982 8.46199 0.78998 7.53754 0.964042 6.63811Z"
        fill="#737373"
      />
      <path
        d="M13.1053 11.4591C13.2602 11.2305 13.5714 11.1707 13.8 11.3256C14.0285 11.4805 14.0883 11.7917 13.9334 12.0203C13.418 12.781 12.7605 13.4354 11.9979 13.948C11.7688 14.1019 11.4586 14.041 11.3045 13.8119C11.1505 13.5828 11.2114 13.272 11.4406 13.1179C12.0967 12.6769 12.6619 12.1136 13.1053 11.4591Z"
        fill="#737373"
      />
      <path
        d="M14.4504 6.24228C14.7215 6.18982 14.9838 6.36703 15.0363 6.63811C15.2104 7.53752 15.2104 8.46201 15.0363 9.36142C14.9838 9.63253 14.7215 9.80972 14.4504 9.75725C14.1793 9.70475 14.0021 9.4424 14.0545 9.17132C14.2043 8.39746 14.2043 7.60207 14.0545 6.82822C14.0021 6.55712 14.1793 6.29477 14.4504 6.24228Z"
        fill="#737373"
      />
      <path
        d="M4.00115 2.05283C4.23033 1.89878 4.54111 1.95971 4.69516 2.1889C4.84909 2.41806 4.78822 2.72823 4.55909 2.88225C3.90295 3.32329 3.33788 3.88663 2.89438 4.54111C2.73948 4.76972 2.42833 4.82947 2.19972 4.67457C1.97133 4.51967 1.91155 4.20909 2.06626 3.98056C2.58164 3.21994 3.23864 2.56542 4.00115 2.05283Z"
        fill="#737373"
      />
      <path
        d="M2.18854 11.3047C2.41771 11.1507 2.72786 11.2116 2.8819 11.4408C3.32294 12.0969 3.88627 12.662 4.54075 13.1055C4.76936 13.2604 4.82911 13.5715 4.67421 13.8002C4.5193 14.0284 4.20869 14.0883 3.9802 13.9336C3.21948 13.4182 2.56509 12.7607 2.05247 11.9981C1.89849 11.7689 1.95938 11.4587 2.18854 11.3047Z"
        fill="#737373"
      />
    </svg>
  );
}

function ReceivedIcon() {
  return (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" aria-hidden>
      <path
        d="M11.6466 3.64645C11.8419 3.45118 12.1584 3.45118 12.3536 3.64645C12.5489 3.84171 12.5489 4.15822 12.3536 4.35348L5.02031 11.6868C4.82504 11.8821 4.50854 11.8821 4.31328 11.6868L0.979943 8.35348C0.784681 8.15822 0.784681 7.84171 0.979943 7.64645C1.1752 7.45118 1.49171 7.45118 1.68697 7.64645L4.66679 10.6263L11.6466 3.64645Z"
        fill="#166534"
      />
      <path
        d="M14.3133 6.31311C14.5085 6.11785 14.825 6.11785 15.0203 6.31311C15.2156 6.50838 15.2156 6.82488 15.0203 7.02014L10.0203 12.0201C9.82504 12.2154 9.50854 12.2154 9.31328 12.0201L8.31328 11.0201C8.11801 10.8249 8.11801 10.5084 8.31328 10.3131C8.50854 10.1179 8.82504 10.1179 9.02031 10.3131L9.66679 10.9596L14.3133 6.31311Z"
        fill="#166534"
      />
    </svg>
  );
}

function AwaitingIcon({
  exists,
  overdue,
}: {
  exists: boolean;
  overdue?: boolean;
}) {
  if (overdue && !exists) return <AlertCircle className="h-4 w-4 text-red-600" strokeWidth={2} />;
  if (exists) return <ReceivedIcon />;
  return <AwaitingUploadIcon />;
}

export default function DocumentsAwaitingList({
  items,
  mode,
  onViewDocument,
}: {
  items: AwaitingDocumentRow[];
  mode: "expected" | "overdue";
  onViewDocument?: (url: string) => void;
}) {
  const visible = mode === "overdue" ? items.filter((item) => !item.exists) : items;

  if (visible.length === 0) {
    return <p className="py-12 text-center text-sm text-neutral-500">No documents in this tab.</p>;
  }

  return (
    <div className="overflow-hidden rounded-xl border border-[#e9eaeb] bg-white">
      <div className="border-b border-neutral-200 px-2 py-2">
        <p className="text-sm font-medium text-[#0a0a0a]">Document</p>
      </div>
      <ul className="divide-y divide-neutral-200">
        {visible.map((item) => {
          const label = formatUploadType(item.uploadType);
          const documentUrl = item.documentUrl ?? item.fileUrl ?? null;
          const subtitle =
            mode === "overdue"
              ? item.overdueDays
                ? `${item.overdueDays} days overdue${item.expectedBy ? ` · expected by ${formatDateLabel(item.expectedBy)}` : ""}`
                : item.expectedBy
                  ? `Overdue · expected by ${formatDateLabel(item.expectedBy)}`
                  : "Overdue"
              : item.exists
                ? item.receivedAt
                  ? `Received ${formatDateLabel(item.receivedAt)}`
                  : "Received"
                : "Awaiting upload";

          return (
            <li
              key={item.uploadType}
              className={cn(
                "flex items-center gap-2 px-2 py-3",
                !item.exists && mode === "expected" && "opacity-60",
              )}
            >
              <div className="flex h-8 w-8 shrink-0 items-center justify-center p-2">
                <AwaitingIcon exists={item.exists} overdue={mode === "overdue"} />
              </div>
              <div className="min-w-0 flex-1">
                <p
                  className={cn(
                    "truncate text-xs font-medium uppercase",
                    item.exists ? "text-[#0a0a0a]" : "text-neutral-500",
                  )}
                >
                  {label}
                </p>
                <p className="truncate text-xs text-neutral-500">{subtitle}</p>
              </div>
              {mode === "overdue" && !item.exists ? <EscalateBadge /> : null}
              {mode === "expected" && item.exists && documentUrl ? (
                <button
                  type="button"
                  onClick={() => onViewDocument?.(documentUrl)}
                  className="group inline-flex h-5 shrink-0 items-center gap-1 rounded-lg px-1.5 text-xs font-medium leading-none text-blue-600 transition-colors hover:bg-blue-50 hover:text-blue-700"
                >
                  <span className="whitespace-nowrap">View Document</span>
                  <ArrowUpRight
                    className="h-3.5 w-3.5 shrink-0 text-blue-600 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-blue-700"
                    strokeWidth={2}
                  />
                </button>
              ) : null}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
